"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RagStatus = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var CircleStatus_1 = require("../CircleStatus");
var enums_1 = require("../../enums");
var chooseColour = function (ragStatus) {
    if (ragStatus === enums_1.RagStatus.GREEN)
        return CircleStatus_1.CircleStatusColours.GREEN;
    if (ragStatus === enums_1.RagStatus.AMBER)
        return CircleStatus_1.CircleStatusColours.AMBER;
    if (ragStatus === enums_1.RagStatus.RED)
        return CircleStatus_1.CircleStatusColours.RED;
    return CircleStatus_1.CircleStatusColours.GREY;
};
var RagStatus = function (props) {
    return (0, jsx_runtime_1.jsx)(CircleStatus_1.CircleStatus, { colour: chooseColour(props.state) });
};
exports.RagStatus = RagStatus;
